module.exports = __webpack_public_path__ + "static/powerpack-243fb49eac4608232f231a7c39fc90e4.jpg";